module.exports = __webpack_public_path__ + "static/img/BA.8e83352c.png";